/* TOKYO LILY — タレント個別ページ（article.talent）
   - 出演作品カテゴリタブ（TP-11: すべて + product.type でクライアントサイドフィルタ）
   - フォトギャラリー（custom.gallery: 横スクロールナビ + ライトボックス） */
(function () {
  'use strict';

  function initWorksTabs(root) {
    (root || document).querySelectorAll('[data-works-tabs]').forEach(function (tabsWrap) {
      if (tabsWrap.dataset.tlInit === '1') return;
      tabsWrap.dataset.tlInit = '1';

      var section = tabsWrap.closest('.tlp-works-wrap') || document;
      var tabs = tabsWrap.querySelectorAll('.wtab[data-wtab]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');
          var cat = tab.dataset.wtab;
          section.querySelectorAll('.work-card[data-wcat]').forEach(function (card) {
            card.style.display = (cat === 'all' || card.dataset.wcat === cat) ? '' : 'none';
          });
        });
      });
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('.tlp-gallery-wrap').forEach(function (wrap) {
      if (wrap.dataset.tlInit === '1') return;
      wrap.dataset.tlInit = '1';

      var scroll = wrap.querySelector('[data-gal-scroll]');
      if (!scroll) return;

      /* 矢印ナビ: アイテム1枚分ずつスクロール */
      var step = function () {
        var item = scroll.querySelector('.gal-item');
        return item ? item.getBoundingClientRect().width + 16 : 280;
      };
      var prev = wrap.querySelector('[data-gal-prev]');
      var next = wrap.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { scroll.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroll.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* ライトボックス */
      var lb = wrap.querySelector('[data-gal-lb]');
      var lbImg = wrap.querySelector('[data-gal-lb-img]');
      if (!lb || !lbImg) return;

      var close = function () {
        lb.hidden = true;
        lbImg.removeAttribute('src');
        document.body.style.overflow = '';
      };

      scroll.querySelectorAll('[data-gal-item]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var img = btn.querySelector('img');
          lbImg.src = btn.dataset.galFull || (img ? img.currentSrc || img.src : '');
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
        });
      });

      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('[data-gal-close]')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lb.hidden) close();
      });
    });
  }

  function init(root) {
    initWorksTabs(root);
    initGallery(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* テーマエディタでの再描画にも対応 */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (window.TokyoLily && window.TokyoLily.initReveal) window.TokyoLily.initReveal(e.target);
  });
})();
